export const highlight = (content: string, highlight: string, className?: string): string => {
  if (!content) return "";
  if (!highlight) return content;
  const regEx = new RegExp(
    `(${highlight
      .trim()
      .replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
      .replace(/[-,.]/g, ".*?")})`,
    "gi"
  );
  const div = document.createElement("div");
  div.innerHTML = content;
  const elements = [...div.getElementsByTagName("*")];
  if (elements.length === 0) {
    div.innerHTML = div.innerHTML.replace(regEx, /*html*/ `<span class="${className}">$1</span>`);
  } else {
    elements.forEach((el) => {
      el.childNodes.forEach((el) => {
        if (el.nodeType === 3) {
          const content = el.textContent || "";
          el.textContent = content.replace(regEx, /*html*/ `<span class="${className}">$1</span>`);
        }
      });
    });
  }
  // console.log(innerHtml);

  return div.innerHTML.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
};
